// extracted by mini-css-extract-plugin
export default {"selectCustom":"createPayment_selectCustom__VdxH8","selectInfo":"createPayment_selectInfo__10tMA","contact":"createPayment_contact__RnxPp"};